// Import Tailwind CSS
import "./main.css";
import './styles/fonts.css';
import './styles/map.css';
// Import AOS (Animate On Scroll)
import AOS from "aos";
import "aos/dist/aos.css";

// Import htmx
import "htmx.org";

// Import Alpine.js
import Alpine from "alpinejs";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

// Make Alpine available globally
window.Alpine = Alpine;

// Start Alpine
Alpine.start();

// Initialize AOS
AOS.init({
  duration: 800, // Animation duration in ms
  easing: "ease-in-out", // Easing function
  once: true, // Whether animation should happen only once
  offset: 100, // Offset from the original trigger point
});

// Initialize birthday picker when present
const birthdayInput = document.getElementById("birthday-picker");
if (birthdayInput) {
  const maxBirthDate = new Date();
  maxBirthDate.setFullYear(maxBirthDate.getFullYear() - 18);

  flatpickr(birthdayInput, {
    dateFormat: "Y-m-d",
    maxDate: maxBirthDate,
    disableMobile: true,
    monthSelectorType: "static",
    allowInput: false,
  });
}

// Optional: Log when everything is loaded
console.log("✨ Vite + htmx + Alpine.js + AOS loaded!");
